import React from 'react';
import mafrid from '../../../images/mafrid.jpg';
import mefta from '../../../images/mefta.jpg';
import './Testimonials.css'

const Testimonials = () => {
    return (
        <div className="container m-3">
            <h4>Testimonials</h4>
            <hr style={{width: '12%',height: '2px', color:'blue'}}/>
            <div className="row align-self-center ms-auto mr-auto">
            <div className="row col-md-5 m-2">
                <div className="row review-area shadow bg-body rounded">
                    <div className="col-md-3 p-3 align-self-center">
                        <img className="client-pic" src={mafrid} alt=""/>
                    </div>
                    <div className="col-md-7 p-3 me-0">
                        <p className="fst-italic fw-bold">"Rafee is a Trustworthy person, regularly comes up with creative solutions to problems"</p>
                        <br />
                        <h6>Mafrid Haydar</h6>
                        <small className="client-designation">CEO,Ask Plan</small>
                    </div> 
                </div>
            </div>
            <div className="row col-md-5 m-2">
                <div className="row review-area shadow bg-body rounded">
                    <div className="col-md-3 p-3 align-self-center">
                        <img className="client-pic" src={mefta} alt=""/>
                    </div>
                    <div className="col-md-7 p-3 me-0">
                        <p className="fst-italic fw-bold" >"This man gets a clear vision of the project before jumping into it.Clears all the confusion.Love to work with him."</p>
                        <br />
                        <h6>Meftaul Islam</h6>
                        <small className="client-designation">Managing Director,Hutum.</small>
                    </div> 
                </div>
            </div>
            </div>
            
        </div>
    );
};

export default Testimonials;